module.exports = __webpack_public_path__ + "static/media/icon-file-upload.b92f15dd.svg";